import {combineEpics, ofType, PledgerAction, PledgerEpic} from "@pledger/frontend-commons";
import {AppActions} from "../app/AppActions";
import {ShowPageActions} from "../app/Pages/ShowPageActions";
import {WServiceActions} from "../../services/ws/WServiceActions";
import {map} from "rxjs/operators";
import {StartEnrollmentActions} from "./StartEnrollmentActions";
import {PostEnrollmentSigninJSON} from "../../services/ws/enrollmentToken/dto/PostEnrollmentSigninJSON";
import {enrollmentTokenWServiceActions} from "../../services/ws/enrollmentToken/enrollmentTokenWServiceActions";

/*const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());*/

const tokenReceivedEpic : PledgerEpic<any> = (actions$) =>
    actions$.pipe(
        ofType(WServiceActions.GET_ENROLLMENT_TOKEN_SUCCEEDED_ACTION.type),
        map((action : PledgerAction) => {
            return ShowPageActions.SHOW_ENROLLMENT_ACTION.build(false);
        }));

const startEnrollmentLoadedEpic : PledgerEpic<any> = (actions$) =>
    actions$.pipe(
        ofType(StartEnrollmentActions.START_ENROLLMENT_LOADED.type),
        map((action : PledgerAction) => {
            const email=action.payload.email ?? '';
            const code = action.payload.code ?? '';

            if (email!=='' && code!=='') {
                const postEnrollmentSigninJSON: PostEnrollmentSigninJSON = {
                    identifier: email,
                    password: code
                };
                return enrollmentTokenWServiceActions.GET_ENROLLMENT_TOKEN_ACTION.build(postEnrollmentSigninJSON);
            }
            else {
                return AppActions.EMPTY_ACTION.build();
            }
        }));

export const startEnrollmentEpics = combineEpics(
    tokenReceivedEpic,
    startEnrollmentLoadedEpic
);
